import { Stack, Typography } from '@mui/material';
import { NEWLINE_REGEX } from '../../domain/key-takeaways';

type HelperTextProps = {
  characterLimit: number;
  value: string;
  bulletPointLimit: number;
};

const HelperText = ({
  characterLimit,
  value,
  bulletPointLimit,
}: HelperTextProps) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography>
        Characters remaining: {characterLimit - value.length}/{characterLimit}
      </Typography>
      <Typography>
        Bullet points remaining:{' '}
        {bulletPointLimit - value.split(NEWLINE_REGEX).length}/
        {bulletPointLimit}
      </Typography>
    </Stack>
  );
};

export default HelperText;
